import React from 'react';
import { faSave } from '@fortawesome/free-solid-svg-icons';
import { ToolButton } from '../../../../components';
import { IToolButtonProps } from '../../../../interfaces';
import { getCurrentData, publish, useSubscription } from '../../../../hooks';
import { StateTopicEnum } from '../../../../enums';
import { UserItemProps } from '..';
import { UserPermissions } from '../../../../../src/definitions';
import { securityService } from '../../../../../src/_global/services';
import { IUserUpdateSingleArgs } from '../../../../interfaces/IUpdateSingleArgs';
import mapUserUpdateArgs from '../../../../utilities/mapUserUpdateArgs';

export default function SaveButton({ config, item }: IToolButtonProps) {
  const { id: moduleId, services } = config;
  const { _id: itemId } = item;
  const [invalid, setInvalid] = React.useState(true);
  const [userEditItem, setUserEditItem] = React.useState(item);

  useSubscription(StateTopicEnum.IsValid, (valid: boolean) =>
    setInvalid(!valid)
  );

  useSubscription(StateTopicEnum.EditItem, (editItem: UserItemProps) =>
    setUserEditItem(editItem)
  );

  const handleClick = async () => {
    delete userEditItem.has_awayz_access;
    delete userEditItem.roles;
    delete userEditItem.is_password_reset;

    userEditItem.email_address = userEditItem.email_address
      .trim()
      .toLowerCase();
    if (userEditItem.source) userEditItem.source = userEditItem.source.trim();

    const updateUserArgs: IUserUpdateSingleArgs = mapUserUpdateArgs(userEditItem);
    
    await services.update?.({ ...updateUserArgs, key: itemId });
    const pageNo = getCurrentData(StateTopicEnum.LibraryPage);
    const searchTerm = getCurrentData(StateTopicEnum.LibrarySearch);
    publish(StateTopicEnum.LibrarySearchAndPage, {
      page: pageNo,
      search: searchTerm
    });
    publish(StateTopicEnum.Refresh, new Date());
    return true;
  };

  return (
    <ToolButton
      text='Save'
      icon={faSave}
      path={`/${moduleId}/${itemId}`}
      primary
      raised
      onClick={handleClick}
      invalid={
        invalid || !securityService.checkRoleAccess(UserPermissions.editUsers)
      }
    />
  );
}
